import { useEffect, useState } from 'react';

import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';
import { usePageContentId, usePageSpaceKey } from '@confluence/page-context';
import { createSingleQueryParamHook } from '@confluence/route-manager/entry-points/RouteState.ts';
import { LoadableLazy } from '@confluence/loadable';

const PageUrlAutomationMenu = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageUrlAutomationMenu" */ '../../entry-points/PageUrlAutomationMenu.ts'
			)
		).PageUrlAutomationMenu,
});

const useRunAutomationIdQueryParam = createSingleQueryParamHook('runAutomationId');

// This is the hook that is used to trigger the automation url param modal
// For the old header (GroupedPageButtons), defaulting to true
// For the new header ContentTypesHeader, we need to check the feature gate and only show the modal if it's enabled
export const useAutomationUrlParamTrigger = (featureGateEnabled: boolean = true) => {
	const { showModal } = useDialogs();

	// These return 'undefined' from within modals for some reason, so have to get them here instead of inside PageUrlAutomationMenu
	const [spaceKey] = usePageSpaceKey();
	const [contentId] = usePageContentId();

	// Need to get this here to know if we should call showModal() or not
	const runAutomationIdQueryParam = useRunAutomationIdQueryParam();

	const [isFirstLoad, setIsFirstLoad] = useState(true);

	const shouldShowModal =
		featureGateEnabled && runAutomationIdQueryParam && spaceKey && contentId && isFirstLoad;

	useEffect(() => {
		if (shouldShowModal) {
			// We only want show the modal once on page load
			setIsFirstLoad(false);

			showModal(PageUrlAutomationMenu, {
				spaceKey,
				pageId: contentId,
				preselectedRuleId: parseInt(runAutomationIdQueryParam),
			});
		}
	}, [spaceKey, contentId, shouldShowModal, runAutomationIdQueryParam, showModal]);
};
